import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, inject, Inject } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-purchase-trace-code-dialog',
  templateUrl: './purchase-trace-code-dialog.component.html',
})
export class PurchaseTraceCodeDialogComponent {
  private _clipboard: Clipboard = inject(Clipboard);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { dea_id?: string },
    private _dialogRef: MatDialogRef<PurchaseTraceCodeDialogComponent>
  ) {}

  protected copyCodeInClipboard(): void {
    if (this.data.dea_id) this._clipboard.copy(this.data.dea_id);
  }

  protected onDismiss(): void {
    this._dialogRef.close();
  }
}
